// src/components/filter.
import React, { useState, useMemo, useEffect } from "react"
import PropTypes from "prop-types"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import TableContainer from "./dealerMastertablecontainer"
import { delearProductGet } from "../../../src/store/actions"
import Loadder from "components/Loadder/Loadder"

import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"

import { useSelector, useDispatch } from "react-redux"

function extractIdAndPName(item) {
  return {
    id: item.id,
    agencyName: item.agencyName,
    firstName: item.firstName,
    city: item.city,
  }
}

function DatatableTablesDealerMaster() {
  const columns = useMemo(
    () => [
      // {
      //     Header: ' ',
      //     filterable: false,
      //     Cell: () => {
      //         return <input type="checkbox" className="form-check-input" />;
      //       }
      // },
      {
        Header: "Sr.No",
        accessor: "id",
      },
      {
        Header: "Agency Name",
        accessor: "agencyName",
      },
      {
        Header: "Dealer Name",
        accessor: "firstName",
      },
      {
        Header: "City",
        accessor: "city",
      },
    ],
    []
  )

  let data = []
  const dispatch = useDispatch()

  useEffect(() => {
    // const isUserLoggedIn = localStorage.getItem("isLoggedIn")
    // if (!isUserLoggedIn) {
    //   localStorage.setItem("isLoggedIn", "true")
    //   window.location.reload()
    // }
    dispatch(delearProductGet({}, {}))
  }, [])

  const delearProductData = useSelector(state => state.DelearProductGet)

  if (delearProductData && delearProductData.delearDetails) {
    data = delearProductData.delearDetails.results.data.map(extractIdAndPName)
  }

  //meta title
  document.title = "Dealers"

  return (
    <Loadder active={delearProductData.loading}>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Tables" breadcrumbItem={document.title} />

          <TableContainer
            count={delearProductData.delearDetails.count}
            next={delearProductData.delearDetails.next}
            previous={delearProductData.delearDetails.previous}
            columns={columns}
            data={data}
            isGlobalFilter={true}
            isAddOptions={false}
            customPageSize={10}
            className="custom-header-css"
          />
        </div>
      </div>
    </Loadder>
  )
}
DatatableTablesDealerMaster.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default DatatableTablesDealerMaster
